/**
 * Dashboards turned off for now (product decision 2026-08-12), keyed by the
 * report `value` from getTableList. Disabled values are marked hidden at the
 * registry — every picker (category tabs, sidebar categories, dropdowns)
 * derives from it — and their dedicated routes carry `disabled: true` so
 * direct URLs stop resolving. Reports that share a route with live siblings
 * (the round types, the lead-capture types) are picker-hidden only; the
 * shared route stays up for the live variants. Re-enable by deleting the
 * entry here and the route's `disabled` flag.
 */
export const DISABLED_DASHBOARD_VALUES = new Set([
  // Building
  'AEDInspection', // AED Rounds (shared roundAnalytics route stays)
  'FireExtinguisherInspection', // Fire Extinguisher (shared roundAnalytics route stays)
  'ComprehensiveFeedbackReport', // Comprehensive Feedback
  'InAppFeedbackReport', // In-App Feedback
  'CustomerFeedbackOnSR', // Feedback on Service Request
  'Renewal', // Renewal Report
  'MoveOutReport', // Move Out Inspection
  'ResidentLog', // Resident Log
  'RoofAccessReport', // Roof Access Authorization
  'TenantHVACReport', // Tenant HVAC
  'GuestLog', // Guest Log
  'StaffCheckIn', // Staff Check-In
  'Vacancy', // Vacancy Lead
  'EVRequest', // EV Request (shared leadCapture route stays)
  'RoomRental', // Room Rental (shared leadCapture route stays)
  'FieldMarketing', // Field Marketing (shared leadCapture route stays)
  'EventRegistration', // Registrant List (shared leadCapture route stays)
  // Nav reorg suppressions (2026-08-22 spec) — hidden, not deleted
  'LeadCapture', // last live Marketing & Leads value; suppressing it retires the whole category
  'SocialReputationReport', // multifamily feature
  'CustomFeedbackDashboard', // reserved for the Connect product later
  'collectionDashboard', // Collections (submenu under Invoicing)
  // Portfolio
  // NOTE: 'GlobalInspectionReport' (portfolio Inspection Overview) was a miss in the
  // 2026-08-12 sweep and stayed live; left live deliberately — #3245 replaces its body
  // with the Inspection Compliance matrix in place. Fold it into the next sidenav sweep.
  'GlobalPortfolioMobileEmployee', // Mobile Engineering Report
  'GlobalResidentFeedback', // Resident Feedback
  'GlobalUpsellMatrix', // Upsell Matrix
  'CollectionDashboardGlobal', // Collection Dashboard (2026-09-15, dropped from the portfolio picker)
])
